"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchInvoicesQuery = exports.useCommitInvoiceBatchMutation = exports.usePreviewInvoiceBatchMutation = exports.invoiceApi = void 0;
// api/invoiceApi.ts — IF-004.3: invoice-number preview/commit + billing-log reads.
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.invoiceApi = (0, react_1.createApi)({
    reducerPath: "invoiceApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["invoices"],
    endpoints: function (builder) { return ({
        previewInvoiceBatch: builder.mutation({
            query: function (body) { return ({ url: "/v1/invoice/preview", method: "POST", body: body }); },
        }),
        commitInvoiceBatch: builder.mutation({
            query: function (body) { return ({ url: "/v1/invoice/commit", method: "POST", body: body }); },
            invalidatesTags: ["invoices"],
        }),
        fetchInvoices: builder.query({
            query: function (params) { return ({ url: "/v1/invoice/all", method: "GET", params: params }); },
            providesTags: ["invoices"],
        }),
    }); },
});
exports.usePreviewInvoiceBatchMutation = exports.invoiceApi.usePreviewInvoiceBatchMutation, exports.useCommitInvoiceBatchMutation = exports.invoiceApi.useCommitInvoiceBatchMutation, exports.useFetchInvoicesQuery = exports.invoiceApi.useFetchInvoicesQuery;
